import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { API_URL } from "./constants";
import BookingsList from "./components/BookingsList";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { DemoBookingsList } from "./components/demo-booking/demo-booking-list";

export default function DemoBooking() {
   const { user } = useSelector((state) => state.auth);
   const BookingTypes = useMemo(
      () => ({
         phone: "phone",
         ticket: "ticket",
      }),
      []
   );
   const [bookingType, setBookingType] = useState(
      localStorage.getItem("bookingType") || BookingTypes.phone
   );
   const [values, setValues] = useState({
      firstname: "",
      lastname: "",
      usernumber: "",
      ticketNumber: "",
      valetnumber: "",
      userLocation: "",
      address: "",
      area: user.alias,
      carImage: null,
      ticketImage: null,
      carNumber: "",
      parkingInfo: "",
      parkingInfoOptions: user.parkingInfoOptions || null,
      paymentStatus: false,
      paymentType: "ONLINE",
      serviceType: "pickup",
      dropAddress: ""
   });
   const [bookingsRefresh, setBookingsRefresh] = useState(false);

   const [coords, setCoords] = useState({
      lat: 0,
      long: 0,
   });

   const [isSubmitting, setIsSubmitting] = useState(false);
   const [valetsList, setValetsList] = useState([]);

   const fillCoords = () => {
      const options = {
         enableHighAccuracy: true,
         timeout: 5000,
         maximumAge: 0,
      };

      function success(pos) {
         const crd = pos.coords;

         setCoords({
            lat: crd.latitude,
            long: crd.longitude,
         });
      }

      function error(err) {
         console.warn(`ERROR(${err.code}): ${err.message}`);
         toast.error("Failed to get Coordinates, Please Try Again");
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
   };

   const handleChange = (e) => {
      setValues({
         ...values,
         [e.target.name]: e.target.value,
      });
   };

   const handlePaymentTypeChange = (e) => {
      const paymentSelected = e.target.value;
      if (paymentSelected !== "postpaid") {
         setValues({
            ...values,
            paymentType: paymentSelected,
            paymentStatus: true,
         });
      } else {
         setValues({
            ...values,
            paymentType: "ONLINE",
            paymentStatus: false,
         });
      }
   };
   const handleServiceTypeChange = (e) => {
      const type = e.target.value;
      setValues({
         ...values,
         serviceType: type
      });
   };

   async function fetchValets() {
      const res = await axios.get(`${API_URL}/api/valets`, {
         params: {
            area: user.alias,
         },
      });

      console.log(res.data);
      setValetsList(res.data.valets);
   }

   const renderOptions = () => {
      const options = values.parkingInfoOptions;
      if (options) {
         const buttons = options.map((value) => (
            <button
               onClick={() => setValues({ ...values, parkingInfo: value })}
               className="btn btn-sm btn-light border me-2"
               type="button"
            >
               {value}
            </button>
         ));

         return <div className="mt-2">{buttons}</div>;
      }

      return "";
   };

   useEffect(() => {
      // if (coords.lat && coords.long) {
      fillCoords();
      fetchValets();
      // }
   }, []);

   const handleSubmit = async (e) => {
      e.preventDefault();

      if (!coords.lat || !coords.long) {
         toast.error("Coordinates not available");
      } else {
         console.table({
            ...values,
            ...coords,
         });

         setIsSubmitting(true);

         const fullName = values.firstname;

         const nameParts = fullName.split(" ");

         let firstname = "";
         let lastname = "";

         if (nameParts.length === 1) {
            firstname = nameParts[0];
         } else if (nameParts.length === 2) {
            firstname =
               nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1);
            lastname = nameParts[1];
         } else {
            firstname =
               nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1);
            lastname = nameParts.slice(1).join(" ");
         }

         if (!firstname) {
            firstname = "Guest";
         }

         try {
            // register user
            const userData = {
               firstname,
               lastname,
               phonenumber: `+91${values.usernumber}`,
               pickupCoords: coords,
            };

            const userResponse = await axios.post(
               `${API_URL}/api/admins/register/users`,
               userData
            );
            const newUser = userResponse.data.user;

            console.log({ newUser });

            const formData = new FormData();

            if (values.serviceType == "both") {
               formData.append("pickupAddress", values.address);
               formData.append("dropAddress", values.dropAddress);
            } else if (values.serviceType == "pickup") {
               formData.append("pickupAddress", values.address);
            } else if (values.serviceType == "drop") {
               formData.append("dropAddress", values.dropAddress);
            }

            formData.append("userId", newUser._id);
            formData.append("serviceType", values.serviceType);
            formData.append("valetNumber", `+91${values.valetnumber}`);
            formData.append("userLocation", values.userLocation);
            formData.append("pickupCoords", coords);
            formData.append("lat", coords.lat);
            formData.append("long", coords.long);
            formData.append("area", values.area);
            formData.append("carImage", values.carImage);
            formData.append("ticketImage", values.ticketImage);
            formData.append("vehicleNumber", values.vehicleNumber);
            formData.append("parkingInfo", values.parkingInfo);
            formData.append("paymentType", values.paymentType);
            formData.append("paymentStatus", values.paymentStatus);

            const bookingResponse = await axios.post(
               `${API_URL}/api/callBookings/register`,
               formData
            );

            const x = bookingResponse.data;

            console.log({ data: x });

            setValues({
               ...values,
               valetnumber: "",
               usernumber: "",
               carImage: null,
               ticketImage: null,
               vehicleNumber: "",
               userLocation: "",
               firstname: "Guest",
               address: "",
               dropAddress: "",
               paymentStatus: false,
               paymentType: "ONLINE",
            });

            console.log("YII", x.newOrder.keyNumber);

            const toastData = (
               <div className="d-flex flex-column justify-content-center align-items-start">
                  <p
                     className="mb-0"
                     style={{
                        fontWeight: 500,
                        fontSize: "0.6rem",
                        letterSpacing: 1.1,
                     }}
                  >
                     BOOKING SUCCESSFUL
                  </p>
                  <p
                     className="mb-0 mt-1"
                     style={{
                        fontWeight: 600,
                        fontSize: "1rem",
                        letterSpacing: 1.1,
                     }}
                  >
                     KEY NO. {x.newOrder.keyNumber}
                  </p>
               </div>
            );

            toast.success(toastData, {
               position: "top-right",
               autoClose: 5000,
               hideProgressBar: false,
               closeOnClick: true,
               pauseOnHover: false,
               draggable: true,
               progress: undefined,
            });
            setIsSubmitting(false);
            setBookingsRefresh((prev) => !prev);
         } catch (err) {
            if (
               err.response &&
               err.response.data &&
               err.response.data.error &&
               Object.keys(err.response.data.error).length
            ) {
               console.log({ errorBoi: err.response });
               toast.error(
                  err.response.data.error || err.response.data.message
               );
            } else {
               console.log(err.response);
               toast.error("Some error occured, try again");
            }
            setIsSubmitting(false);
         }
      }
   };

   const handleTicketSubmit = async (e) => {
      e.preventDefault();

      if (!coords.lat || !coords.long) {
         toast.error("Coordinates not available");
      } else {
         console.table({
            ...values,
            ...coords,
         });

         setIsSubmitting(true);

         try {
            // register booking
            const bookingData = {
               ticketNumber: `${user.alias}${values.ticketNumber}`,
               pickupAddress: values.address,
               valetNumber: `+91${values.valetnumber}`,
               lat: coords.lat,
               long: coords.long,
               area: values.area,
               vehicleNumber: values.vehicleNumber,
            };

            const bookingResponse = await axios.post(
               `${API_URL}/api/ticket-bookings/`,
               bookingData
            );

            const x = bookingResponse.data;

            console.log({ data: x });

            setValues({
               ...values,
               valetnumber: "",
               ticketNumber: "",
               carImage: null,
               ticketImage: null,
               vehicleNumber: "",
            });

            toast.success("Request Submitted Successfully");
            setIsSubmitting(false);
            setBookingsRefresh((prev) => !prev);
         } catch (err) {
            if (
               err.response &&
               err.response.data &&
               err.response.data.error &&
               Object.keys(err.response.data.error).length
            ) {
               console.log({ errorBoi: err.response });
               toast.error(
                  err.response.data.error || err.response.data.message
               );
            } else {
               console.log(err.response);
               toast.error("Some error occured, try again");
            }
            setIsSubmitting(false);
         }
      }
   };

   return (
      <div>
         <div className="container">
            <div className="d-flex align-items-center flex-column">
               <img
                  src={user.brandImage}
                  alt={user.fullname}
                  className="partners-logo"
               />
               <p className="text-center">Booking Panel</p>
            </div>
            <ul
               className="nav nav-tabs justify-content-center mt-4"
               style={{ maxWidth: 700, width: "95%", margin: "20px auto 0" }}
            >
               <li className="nav-item">
                  <button
                     onClick={() => {
                        setBookingType(BookingTypes.phone);
                        localStorage.setItem("bookingType", BookingTypes.phone);
                     }}
                     className={`nav-link btn-sm  ${bookingType === BookingTypes.phone
                        ? "text-dark active"
                        : "text-secondary"
                        }`}
                     style={{
                        fontWeight:
                           bookingType === BookingTypes.phone ? 500 : 400,
                     }}
                  >
                     Phone No. Booking
                  </button>
               </li>
            </ul>
            <form
               onSubmit={
                  bookingType === BookingTypes.phone
                     ? handleSubmit
                     : handleTicketSubmit
               }
               style={{ maxWidth: 700, width: "95%", margin: "20px auto 0" }}
            // className="w-100"
            >

               {/* phone number section */}
               <div className="row">
                  <div className="form-group mb-2 col">
                     <div className="input-group">
                        <input
                           name="usernumber"
                           value={values.usernumber}
                           onChange={handleChange}
                           type="number"
                           required
                           className="form-control"
                           id="usernumber"
                           placeholder="User Phone Number"
                        />
                     </div>
                  </div>

                  <div className="form-group mb-4 col-md">
                     <div className="input-group">
                        <input
                           name="valetnumber"
                           value={values.valetnumber}
                           onChange={handleChange}
                           type="number"
                           className="form-control"
                           id="valetnumber"
                           placeholder="Valet Phone Number"
                        />
                     </div>
                  </div>
               </div>
               {/* phone number section end */}


               {/* select valet and service toggle  */}
               <div className="row">

                  <div className="col">
                     <div className="switch service-type-switch">
                        <input
                           id="service-pickup"
                           name="serviceType"
                           type="radio"
                           value="pickup"
                           className="switch-input"
                           checked={values.serviceType === "pickup"}
                           onChange={handleServiceTypeChange}
                        />
                        <label htmlFor="service-pickup" className="switch-label switch-label-pickup">
                           Pick Up
                        </label>

                        <input
                           id="service-drop"
                           name="serviceType"
                           type="radio"
                           value="drop"
                           className="switch-input"
                           checked={values.serviceType === "drop"}
                           onChange={handleServiceTypeChange}
                        />
                        <label htmlFor="service-drop" className="switch-label switch-label-drop">
                           Drop
                        </label>

                        <input
                           id="service-both"
                           name="serviceType"
                           type="radio"
                           value="both"
                           className="switch-input"
                           checked={values.serviceType === "both"}
                           onChange={handleServiceTypeChange}
                        />
                        <label htmlFor="service-both" className="switch-label switch-label-both">
                           Both
                        </label>

                        <span className="switch-selector"></span>
                     </div>
                  </div>

                  {/* Service toggle ends  */}

                  <div className="w-100 col">
                     <a
                        className={"btn btn-sm show-valets-btn btn-dark w-100"}
                        data-bs-toggle="offcanvas"
                        href="#offcanvasExample"
                        role="button"
                        aria-controls="offcanvasExample"
                     >
                        Show Valets
                     </a>
                  </div>

               </div>


               <div className="form-group my-4">
                  <label htmlFor="addressInfo" className="form-label">
                     Address
                  </label>
                  <div className="input-group">
                     <input name="address" value={values.address} onChange={handleChange} disabled={values.serviceType == "drop"} type="text" class="form-control" placeholder="Pick up Address" aria-label="pickupAddress" />
                     <span class="input-group-text bg-dark text-white">&</span>
                     <input name="dropAddress" value={values.dropAddress} onChange={handleChange} disabled={values.serviceType == "pickup"} type="text" class="form-control" placeholder="Drop Address" aria-label="dropAddress" />
                  </div>
               </div>

               <div className="row">

               <div className="form-group col-md mb-2">
                  <label htmlFor="vehicleNumber" className="form-label">
                     Vehicle Number
                  </label>
                  <div className="input-group">
                     <input
                        name="vehicleNumber"
                        value={values.vehicleNumber}
                        onChange={(e) => {
                           e.target.value = e.target.value.toUpperCase();
                           handleChange(e);
                        }}
                        type="text"
                        className="form-control"
                        id="vehicleNumber"
                        placeholder="UK08AB1234"
                     />
                   
                  </div>
               </div>

               <div className="form-group col">
                  <label htmlFor="addressInfo" className="form-label">
                     Schedule Booking
                  </label>
                  <div className="input-group">
                     <input
                        type="date"
                        className="form-control"
                        id="booking-date"
                        defaultValue={new Date().toISOString().split("T")[0]}
                        // value={selectedDate}
                        onChange={(e) => (e.target.value)}
                        // min={today}
                        // max={maxDate}
                        required
                     />
                     <span class="input-group-text bg-dark text-white">&</span>
                     <input
                        type="time"
                        className="form-control"
                        id="booking-time"
                        defaultValue={new Date().toLocaleTimeString("en-US", {
                           hour12: false,
                           hour: "2-digit",
                           minute: "2-digit",
                         })} 
                        // value={selectedTime}
                        onChange={(e) => (e.target.value)}
                         // 30 minutes in seconds
                        required
                     />
                  </div>
                  {/* <small className="form-text text-muted">
                     select a time between 9:00 AM and 5:00 PM
                  </small> */}
               </div>

               </div>

               <div className="input-group my-4">
                  <input
                     name="coords"
                     required
                     type="text"
                     value={
                        coords.lat && coords.long
                           ? `${coords.lat}, ${coords.long}`
                           : "Click Fill coodinates"
                     }
                     className="form-control"
                     id="coords"
                     disabled
                     placeholder="Coordinates"
                  />
                  <button
                     type="button"
                     className="btn btn-success btn-sm"
                     onClick={fillCoords}
                  >
                     Fill Coordinates
                  </button>
               </div>
               <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-dark mt-2 px-4 w-100"
               >
                  {isSubmitting ? (
                     <>
                        <span
                           className="spinner-border spinner-border-sm me-2"
                           role="status"
                           aria-hidden="true"
                        ></span>
                        <span>Submitting...</span>
                     </>
                  ) : (
                     <span >Submit</span>
                  )}
               </button>
            </form>
         </div >

         <hr className="mt-5 mb-4" />

         <DemoBookingsList bookingsRefresh={bookingsRefresh} />

         <div
            className="offcanvas offcanvas-start"
            tabIndex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
         >
            <div className="offcanvas-header">
               <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                  Valets List
               </h5>
               <button
                  type="button"
                  className="btn-close text-reset hide-valets-btn"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
               ></button>
            </div>
            <div className="offcanvas-body">
               <ul className="list-group">
                  {valetsList.map((v) => (
                     <li
                        key={v._id}
                        className="list-group-item cursor-pointer list-group-item-action"
                        onClick={() => {
                           setValues({
                              ...values,
                              valetnumber: v.phonenumber.slice(3),
                           });
                           document.querySelector(".hide-valets-btn").click();
                        }}
                     >
                        {v.firstname + " " + v.lastname} {v.phonenumber}
                     </li>
                  ))}
               </ul>
            </div>
         </div>
      </div >
   );
}